<template>
	<!--pdf查看器-->
	<div id="pdf_box"  class="maxbox" >
		<!--菜单栏-->		
		<div class="pdf_titleBar" >
			<!--打开本地pdf-->
			<div  class="openTheLocal" >
				<input type="file"  accept="application/pdf" @change="fileChange"/>
				<span><i class="iconfont icon-tubiaozhizuomoban"></i>打开文件</span>
			</div>
			
			<!--打印-->
			<div class="pdf_print hover_div" @click="print() ">
				<span>
					<i class="iconfont icon-dayin"></i>
					打印
				</span>
				<iframe src="" style="opacity: 0;" id="ifr" width="0" height="0"></iframe>
			</div>
			
			
			<!--放大缩小-->
			<div class="zoomInOut">
				<span @click="scale_size('big')"><i class="iconfont icon-fangda hover_div" ></i></span>
				<span @click="scale_size('small')"><i class="iconfont icon-suoxiao hover_div" ></i></span>
			</div>
			
			<!--pdf旋转-->
			<div class="pdf_rotate">
				<i class="iconfont iconicon_rotate  hover_div" @click="rotate_angle('left')"></i>
				<i class="iconfont iconicon_rotate  hover_div" @click="rotate_angle('right')"></i>
			</div>
			
			<!--页码-->
			<div class="pdf_page_num">
				<i class="iconfont icon-zuo" @click="skip('forward')"></i>
				<span class="page_num" >
					<input type="text" class="page_inp" v-model="currentPage" @keyup="jump()" /> 
					/ {{pageCount}}
				</span>
				<i class="iconfont iconicon-arrow-right2" @click="skip('next')"></i>
			</div>
			
			<!--刷新-->
			<!--<div class="refresh">
				<i class="iconfont icon-shuaxin" @click="download()"></i>
			</div>-->
			
			
			
			<!--文本查询-->
			<div class="pdf_seek" >
				<p>
					<input type="text"  />
					<i class="iconfont icon-fangdajing"></i>
				</p>
			</div>
			
			
			<!--弹窗状态栏-->
			<div class="box_state">
				<!--关闭-->
				<div class="pdf_close pdf_box_state  hover_div " @click="close()">
					<i class="iconfont iconicon1"></i>
				</div>
				<!--弹窗显示-->
				<!--<div class="pdf_popup pdf_box_state hover_div" @click="max_box()">
					<i class="iconfont icon-xinchuangkoudakai"></i>
				</div>-->
			</div>
		</div>
		
		<div class="showFile_nav" :class="max?'fangda_pdf':''">
			<!--pdf显示-->
				<!--txt显示-->
				<pdf  
					v-if="cType=='application/txt'"
					v-for="i in pageCount"
					:src="src"
		            :key="i"
		            :page="currentPage"
		            class="pdf_text pdf_text_size"
					>
				</pdf>
				<!--其他pdf显示-->
				<div v-if="cType=='application/pdf'"  ref="pdfShow"></div>
			
			
			<!--图片显示-->
				<img v-if="cType!='application/pdf'&&cType!='application/txt'"  class="pdf_text img_nav" :style="{transform:'translateX(-50%)rotateZ('+rotate+'deg)scale('+scalePdf+')'}"  :src="imgsrc" />
			
		</div>
	</div>
</template>

<script>
	import pdf from 'vue-pdf'
	import PDFJS from 'pdfjs-dist-di'
	
	
	export default {
		data () {
	    return {
	    		dataFile:null,//原PDF文件储存空间
	    		src:null,//原PDF显示url
	    		currentPage: 1,//当前页码
           		pageCount: 1,//总页数
           		numPages:1,//显示多少页
				max:false,//窗口是否最大化
           		rotate:0,//内容旋转度数
           		imgsrc:null,//打印承载图片地址
           		cType:'',//用来判断是什么文件
           		srcPdf:null,
           		
           		scalePdf:1,
           		left:20,
           		top:10,
           		
		      	pageNumPending: null,
		      	
		      	
		      	pdfObj:{
		      		pdf:null,
		      		pagePdf:null,
		      		idTemplate:null,
		      		
		      	},
		      	
		      	
		      	
		      	
	    	}
  		},
	  	props:['menuPdfData'],
  		created:function(){
  			this.getType()
  			
			this.download()
			
  		},
		methods:{
//          预下载便于查看
//				数据流下载
			download(){
				let fileId=this.menuPdfData.fileId;//确认上传文件ID
				let token=this.$user.get_data('userData').token
				let params = new URLSearchParams
					params.append('token',token)
					params.append('fileId',fileId)
				let that=this;
				this.axios({
				    method:"POST",
				    url:'/project/showFile',
					responseType: 'arraybuffer',
					data: params,
//				    headers: {
//					    'Content-Type': this.cType+';charset=UTF-8'
//					}
					headers: {
			          'Content-Type': 'application/x-www-form-urlencoded'
			        }
				})
				.then(function (response) {
					if(response.data.code!=0){
						let blob = new Blob([response.data], {type: that.cType}); 
						that.srcPdf=URL.createObjectURL(blob)
						
						if(that.cType=='application/pdf'){
		          			that.showPDF(that.srcPdf,1)
						}else if(that.cType=='application/txt'){
//		          			that.showPDF(that.srcPdf,1)
							
//							//创建blob对象
							that.gain(that.srcPdf,1)
						}else{
//							that.imgsrc=URL.createObjectURL(blob)
							that.imgsrc=that.menuPdfData.fileUrl
						}
					}
				})
  		 	},
			showPDF(url,page) {
				if(this.cType!='application/pdf'){
					return
				}
		    	this.$refs.pdfShow.innerHTML='';//前置canvas数量为0
		    	this.pdfObj.pagePdf=page;//页码PDF页码
		    		page=page||this.currentPage;//当前页或输入页
		      	let that = this
		      	
		      	
		      	PDFJS.getDocument(url).then(function(pdf) {
		          	that.pageCount = pdf.numPages;//存储pdf总页码
		          	var idTemplate = 'openPdf_'
		          	for (var j = 1; j <= 1; j++) {//创建1个签章canvas对象
						var canvasNew = document.createElement('canvas')
						canvasNew.className='pdf_text pdfCanvas'
						canvasNew.id = idTemplate+j
						that.$refs.pdfShow.appendChild(canvasNew)
					}
		          	
		          	that.pdfObj.pdf=pdf;//暂存pdf文件
		          	that.pdfObj.idTemplate=idTemplate+1;//暂存pdf签章
		          	
		          	that.renderPage(pdf,that.pdfObj.pagePdf,idTemplate+1);//(pdf:pdf对象;that.pagePdf:pdf页码,idTemplate:pdf所属canvas的Id)
		        })
		    },
		    renderPage(pdf,i,id) {
			    let that = this
			    pdf.getPage(i).then(function(page) {
			        let viewport = page.getViewport(that.scalePdf)
			        let canvas = document.getElementById(id)
			       		canvas.height = viewport.height
				        canvas.width = viewport.width
				        canvas.style.height = viewport.height+'px'
				        canvas.style.width = viewport.width+'px'
			        
			        var renderContext = {
			          canvasContext: canvas.getContext('2d'),
			          viewport: viewport
			        }
			        //等待渲染完成
			        page.render(renderContext).promise.then(function() {
			          if (that.pageNumPending !== null) {
			          	//新页面加载
			            this.renderPage(that.pageNumPending)
			            that.pageNumPending = null
			          }
			        })
			    })
		    },
			
			

//			文件类型判断
			getType(){
					let fileSuffix=this.menuPdfData.fileSuffix
					let fileType=this.$utils.regExpFileIco(fileSuffix);//判断文件类型
					if(this.menuPdfData.fileSuffix=='txt'){
						this.cType='application/txt'
						return
					}
					if(fileType!='img'){
						this.cType='application/pdf'
					}else{
						let suffix=this.menuPdfData.fileSuffix
						if(suffix=='png'){
							this.cType='application/x-png'
						}
						if(suffix=='jepg'||suffix=='jpg'){
							this.cType='application/x-jpg'
						}
						if(suffix=='gif'){
							this.cType='image/gif'
						}
						if(suffix=='svg'){
							this.cType='text/xml'
						}
					}
			},
//***********************菜单********************//
			//本地文件读取  暂时不做
			fileChange(el){
//            if (!el.target.files[0].size) return;
//            this.fileList(el.target);
//            el.target.value = ''
				let reader = new FileReader();
                  reader.vue = this;
                  reader.readAsDataURL(el.target.files[0]);
                  reader.onload = function () {
                     this.url=this.result;
//                    this.vue.imgList.push({
//                        file
//                    });
                  }
          	},
          	//页码前后跳转
          	skip(txt){
				if(txt=='forward'){
					this.currentPage=Number(this.currentPage-1)
					if(this.currentPage<=0){
						this.currentPage=1
					}
				}
				if(txt=='next'){
					this.currentPage=Number(this.currentPage+1)
					if(this.currentPage>this.pageCount){
						this.currentPage=this.pageCount
					}
				}
				this.showPDF(this.srcPdf,this.currentPage)
			},
			//指定页跳转
			jump(){
				this.currentPage=Number(this.currentPage)
				if(this.currentPage==undefined||this.currentPage==null||this.currentPage==0||isNaN(this.currentPage)){
					this.currentPage=1
				}
				if(this.currentPage>=this.pageCount){
					this.currentPage=this.pageCount
				}

				this.$forceUpdate()
			},
			//旋转文件
			rotate_angle(txt){
				let rotate_obj=document.querySelector('.pdf_text').style.transform
				if(txt=='left'){
					this.rotate=this.rotate-90
				}
				if(txt=='right'){
					this.rotate=this.rotate+90
				}
				document.querySelector('.pdf_text').style.transform="translateX(-50%)rotateZ("+this.rotate+"deg)"
			},
			//放大缩小
			scale_size(txt){
				if(txt=='big'){
					if(this.scalePdf>2){
						this.scalePdf=2
					}else{
						this.scalePdf=this.scalePdf*0.1+this.scalePdf
					}
				}
				if(txt=='small'){
					this.scalePdf=this.scalePdf-this.scalePdf*0.1
					if(this.scalePdf<0.4){
						this.scalePdf=0.4
					}
				}
				this.renderPage(this.pdfObj.pdf,this.currentPage,this.pdfObj.idTemplate)
			},
			//打印机
			print(){
			    let id_str,dataURL;
			    var iframe = document.createElement('IFRAME');
			    	iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
					document.body.appendChild(iframe);
				var doc = null;
					doc = iframe.contentWindow.document;
				
				
			    	if(this.cType=='application/pdf'){
			    		var canvas=document.getElementsByTagName("canvas")[0];
			    			dataURL=canvas.toDataURL("image/png")
			    			canvas.id="pdfPrint_open"
			   				id_str='pdfPrint_open'
			   				
							doc.write('<img src="'+dataURL+'"/>');
							
							setTimeout(()=>{
								doc.close();

								iframe.contentWindow.focus();
								iframe.contentWindow.print();
								
							},2000)

			    	}else{
			    		doc.write('<img src="'+this.imgsrc+'"/>');
							
						setTimeout(()=>{
							doc.close();

							iframe.contentWindow.focus();
							iframe.contentWindow.print();
							
						},300)
			    	}
			    
				if (navigator.userAgent.indexOf("MSIE") > 0)
				{
				     document.body.removeChild(iframe);
				}
			    

			},
			//窗口放大
			max_box(){
				this.max=!this.max
				this.download()
			},
			//关闭
			close(){
				this.src=null;
				this.currentPage=1;
				this.pageCount=0;
				this.numPages=1;
				this.max=false;
				this.rotate=0;
				this.scale=30;
				this.left=35;
				this.top=0;
				this.imgsrc=null;
				
				this.$emit('openpdf',false)
			},
//*****旧版PDF处理方式*******			
			//pdf处理
			gain(url,page){
//		    	this.pdfObj.pagePdf=page;//页码PDF页码
//		    		page=page||this.currentPage;//当前页或输入页
//		      	let that = this
//		      	
//		      	PDFJS.getDocument(url).then(function(pdf) {
//
//		      		
//		          	that.pageCount = pdf.numPages;//存储pdf总页码
//		          	
////		          	that.pdfObj.pdf=pdf;//暂存pdf文件
//		          	
////		          	that.renderPageTxt(pdf,that.pdfObj.pagePdf,idTemplate+1);//(pdf:pdf对象;that.pagePdf:pdf页码,idTemplate:pdf所属canvas的Id)
//		        })
				
				
				
				
				let loadingTask = pdf.createLoadingTask(url);
				this.src=loadingTask;
				
				
				
				let loding_pdf=setInterval(() => {
					if(this.src._transport!=null){
					    this.pageCount=this.src._transport.numPages
                  		clearInterval(loding_pdf)	
					}else{
	                  	clearInterval(loding_pdf)	
					}
            	}, 500);
			},
			
		},
		components:{
			pdf
  		},
  		directives:{
//			拖动自定义指令
            drag(el,bindings){
                el.onmousedown = function(e){
                	e.preventDefault()
					let init_left=e.clientX
					let init_top=e.clientY
                    document.onmousemove = function (el){
                    	e.preventDefault()
                    	let mvLeft=(el.clientX-init_left)
						let mvTop=(el.clientY-init_top)
						
            			bindings.value.set(mvLeft,mvTop)
						
                    	document.getElementsByClassName('img_nav')[0].style.cursor='move'
                    	
                    }
                    document.onmouseup = function(){
                        document.onmousemove = null
                        document.onmouseup = null;
                        
                        bindings.value.rec_set()
                        
                    }
//                  document.getElementsByClassName('img_show')[0].onmouseleave=function(){
//                      document.onmousemove = null;
//                  }
                }
            }
        }
	}
</script>

<style>
	#pdf_box{
		width: 100%;
		height: 100%;
		background: rgba(55,55,55,0.7);
		box-sizing: border-box;
		overflow: hidden;
		left: 0;
	    top: 0;
	    z-index: 99999;
	}
	.ifRame{
		width: 600px;
		height: 800px;
		position: absolute;
		left: 30%;
		top: 10%;
		background: #fff;
	}
/*小窗口*/
	.minbox{
		position: absolute;
	}
/*大窗口*/	
	.maxbox{
		position: fixed;
	}

	.pdf_min_box{
		position: relative!important;
	    
	}
	.pdf_max_box{
		position: absolute!important;
	}
	.pdf_text{
		display: block;
		margin-left: 50%;
		margin-top: 100px;
		transition: all 300ms; 
		transform: translateX(-50%);
	 }
	
/*********************************菜单栏*************/
	.pdf_titleBar{
		float: left;
	 	font-size: 16px;
	 	height: 40px;
	 	width:inherit;
	 	background:rgb(50, 54, 57);
	 	z-index: 200;
	 	color: #000;
		line-height: 40px;
		position: absolute;
	}
	.pdf_titleBar div{
		color: rgb(241, 241, 241);
	}
	.pdf_titleBar div i{
		color: rgb(241, 241, 241)!important;
	}
	.pdf_titleBar .hover_div:hover{
		color: #409EFF!important;
	}
	.pdf_titleBar .hover_div:hover i{
		color: #409EFF!important;
	}
	#pdf_box .pdf_titleBar .iconfont{
		font-size: 22px;
		margin-right: 5px;
	}
	/*打开本地*/
	#pdf_box .openTheLocal{
		width: 120px;
		height: 40px;
		float: left;
		text-align: center;
		cursor: pointer;
		position: relative;
		display: none;
	}
	#pdf_box .openTheLocal input{
		position: absolute;
		left: 0;
		top: 0;
		opacity: 0;
		z-index: 100;
		width: 120px;
		height: 40px;
		cursor: pointer;
	}
	#pdf_box .openTheLocal:hover{
		box-shadow:inset 0 0 16px 2px #333 ;
	}
	/*打印*/
	#pdf_box .pdf_print{
		width: 120px;
		height: 40px;
		float: left;
		text-align: center;
		cursor: pointer;
		margin-left: 20px;
	}
	#pdf_box .pdf_print:hover{
			box-shadow:inset 0 0 16px 2px #333 ;
		}
	
	/*放大缩小*/
	#pdf_box .zoomInOut{
		width: 180px;
		height: 40px;
		float: left;
		cursor: pointer;
		margin-left: 20px;
	}
	#pdf_box .zoomInOut span{
		width: 40px;
		height: 40px;
		display: inline-block;
		transition: all 300ms;
		text-align: center;
	}
	#pdf_box .zoomInOut span:hover{
		box-shadow:inset 0 0 16px 2px #333 ;
	}
	#pdf_box .zoomInOut span:nth-child(1){
		float: left;
		margin-right: 20px;
	}
	#pdf_box .zoomInOut span:nth-child(2){
		float: left;
	}
	/*页码跳转*/
	#pdf_box .pdf_page_num{
		margin-left: 180px;
		width: 180px;
		height: 40px;
		float: left;
	}
	#pdf_box .pdf_page_num i{
		color: #666;
		display: inline-block;
		width: 28px;
		height: 40px;
		font-size: 22px!important;
		line-height:48px;
		float: left;
		cursor: pointer;
		transition: all 100ms; 
		text-align: center;
	}	
	#pdf_box .pdf_page_num i:hover{
		box-shadow:inset 0 0 12px 2px #333 ;
	}
	#pdf_box .page_num{
		float: left;
		width: 100px;
		height: 40px;
	}
	#pdf_box .pdf_page_num .page_inp{
		width: 40px;
		text-align: center;
		height: 25px;
	}
	/*旋转*/
	#pdf_box .pdf_rotate{
		width: 100px;
		height: 40px;
		float: left;
	}
	#pdf_box .pdf_rotate i{
		display: inline-block;
		width: 40px;
		height: 40px;
		margin: 0!important;
		color: #666;
		text-align: center;
		cursor: pointer;
		box-sizing: border-box!important;
	}
	#pdf_box .pdf_rotate i:hover{
		box-shadow:inset 0 0 12px 2px #333 ;
	}
	#pdf_box .pdf_rotate i:nth-child(1){
		padding-top: 5px;
		transform: rotateY(180deg) rotateZ(90deg);
	}
	#pdf_box .pdf_rotate i:nth-child(2){
		padding-top: 5px;
		transform: rotateZ(90deg);
	}
	/*文本搜索*/
	#pdf_box .pdf_seek{
		width: 170px;
		height: 40px;
		margin-left: 160px;
		float: left;
		opacity: 0;
		
	} 
	#pdf_box .pdf_seek p{
		width: 170px;
		height: 26px;
		border: 1px solid #A0A0A0;
		margin-top: 7px;
		border-radius:4px ;
		overflow: hidden;
	}
	#pdf_box .pdf_seek input{
		border: none;
		outline: none;
		width: 140px;
		height: 24px;
		float: left;
		padding-left: 8px;
		box-sizing: border-box;
	}
	#pdf_box .pdf_seek i{
		cursor: pointer;
		width: 28px;
		height: 24px;
		line-height: 30px;
		float: left;
		text-align: center;
		font-size: 20px!important;
		border-left:1px solid #A0A0A0 ;
		display: inline-block;
		margin: 0!important;
		color: #fff;
		background: #57B497;
	}
	/*pdf框状态栏*/
	#pdf_box .box_state{
		width: 120px;
		height: 40px;
		float: right;
		color: #666;
	}
	#pdf_box .pdf_box_state{
		width: 40px;
		height: 40px;
		text-align: center;
		line-height: 45px;
		float: right;
		cursor: pointer;
		box-sizing: border-box;
		padding-left: 5px;
		transition: all 300ms; 
	}
	#pdf_box .pdf_popup:hover{
		box-shadow:inset 0 0 15px 0px #333 ;
		color: #57B497;
	}
	#pdf_box .pdf_close:hover{
		box-shadow:inset 0 0 15px 0px #333 ;
		color: #F56C6C;
	}
	/*功能图标*/
	#pdf_box .pdf_titleBar .icon-tubiaozhizuomoban{
		color: #efb336;
	}
	#pdf_box .pdf_titleBar .icon-dayin{
		color: #1890FF;
	}
	#pdf_box .pdf_titleBar .icon-suoxiao{
		color: #333;
		font-size: 18px;
	}
	#pdf_box .pdf_titleBar .icon-fangda{
		color: #333;
		font-size: 18px;
	}
	
/************显示内容区域*/
	.showFile_nav{
		width: inherit;
		height: inherit;
		float: left;
		overflow-y: scroll;
		padding: 20px 0px;
		box-sizing: border-box;
		z-index: 10;
	}
	.fangda_pdf{
		height:inherit;
	}
	/*图片*/
	.img_nav{
		height:600px;
	}
 
</style>


// WEBPACK FOOTER //
// src/components/paging/pcClient/popupModule/checkTheRelated/pdf_look.vue